import httpRequest from 'httpRequest'
import { PaymentSettingContract } from 'models'

const PAYMENT_SETTING_PREFIX = '/location/pos-payment-settings'

const posPaymentSettingService = {
    getPosPaymentSettings: () =>
        httpRequest.get<PaymentSettingContract[]>(PAYMENT_SETTING_PREFIX),
    getPaymentSettingById: (paymentSettingId: string) =>
        httpRequest.get<PaymentSettingContract>(
            `${PAYMENT_SETTING_PREFIX}/${paymentSettingId}`,
        ),
    updatePaymentSetting: (
        paymentSettingId: string,
        body: PaymentSettingContract,
    ) => httpRequest.put(`${PAYMENT_SETTING_PREFIX}/${paymentSettingId}`, body),
    udpateSortPosPayment: (contract: PaymentSettingContract[]) =>
        httpRequest.put(`${PAYMENT_SETTING_PREFIX}/sort`, contract),
    updatePOSActivePayment: (paymentSettingId: string, isActive: boolean) =>
        httpRequest.put(
            `${PAYMENT_SETTING_PREFIX}/${paymentSettingId}/set-active`,
            {},
            { params: { isActive } },
        ),
}

export default posPaymentSettingService
